const H = {
  name: "Bank",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.67953 2H14.3205L22 7.48538V11H19V20H22V22H2V20H5V11H2V7.48538L9.67953 2ZM7 20H9V11H7V20ZM11 20H13V11H11V20ZM15 20H17V11H15V20ZM20 9V8.51462L13.6795 4H10.3205L4 8.51462V9H20Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Bank
};
